<template>
  <div>
    <PublicPageHeader
      :title="'All Resource'"
      :description="
        'Find resources such as text files, videos, audios, worksheets, assessments, PDFs, and other materials that can be used to assist students in learning and implementing interventions. These resources have been contributed by the experts and members of the community. Assign these resources to the respective students from the platform.'
      "
      :image="headerImage"
    />
    <v-container>
      <ResourceList class="mt-10" />
    </v-container>
  </div>
</template>

<script>
  import ResourceList from "../Client/Resources/List/ClientResourceList";
  import PublicPageHeader from "./component/PublicPageHeader";
  import AmplitudeHelper from "../../amplitude";

  export default {
    name: "PublicResourceList",
    components: {
      ResourceList,
      PublicPageHeader,
    },
    data() {
      return {
        headerImage: require("@/assets/allResource.svg"),
      };
    },
    created() {
      AmplitudeHelper.registerAmplitudeEvent("view resource page");
    },
    computed: {},
    watch: {},
    methods: {},
    mounted() {},
  };
</script>

<style scoped></style>
